<!-- scroll down -->
<a class="scroll-dwn" 
    [href]="link"
    [ngClass]="(color == 'white')?'white':'blue'">
    <!-- icon white -->
    <img class="icon" 
        *ngIf="color == 'white'"
        src="../../../assets/images/icon/arrow-down.svg" 
        alt="">
    <!-- icon blue -->
    <img class="icon" 
        *ngIf="color == 'blue'"
        src="../../../assets/images/icon/arrow-down-blue.svg" 
        alt="">
</a>